import React, { useEffect, useState } from 'react'
import TempBoxWhite from '../../template/temp-box-white'
import bg from '../../../assets/image/item-discount.png'
import Text from '../../atoms/text'
import Button from '../../atoms/button'
import IconCardShopProduct from '../../../assets/image/plus.png'
import useGetDetailProduct from '../../../hooks/use-get-detail-product'
import usePostAddToCart from '../../../hooks/use-post-add-to-cart'
import { useCart } from '../../../context/CartContext'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import Delete from '../../../assets/image/Iconly/Bold/Delete.png'
import Rial from '../../../assets/image/Iconly/Iconly/Bold/Frame.png'
import AvatarButton from '../avatar-button'
import Cookies from "js-cookie";



function ContentProduct() {
    const {data} = useGetDetailProduct();
    // console.log(data)
    const { cart, addToCart, updateQuantity, removeFromCart } = useCart();
    const accessToken = Cookies.get('access');

    const [mainImage, setMainImage] = useState("");

    // زمانی که دیتا از API میاد، اولین عکس رو ست کن
    useEffect(() => {
        if (data?.data) {
            const images = Array.isArray(data.data.images) ? data.data.images : [];
            const all = [data.data.image, ...images.map(img => img.image)];
            setMainImage(all[0]); // 👈 عکس اول به عنوان پیش‌فرض
        }
    }, [data]);
    // console.log(cart)
    
    const images = Array.isArray(data?.data?.images) ? data.data.images : [];
    const allImages = [data?.data?.image, ...images.map(img => img.image)];
    // console.log(allImages)

    // const [mainImage, setMainImage] = useState(allImages[0]);

    const handleClick = (data) => {
        addToCart(data)
        toast.success('تمت الإضافة إلى سلة التسوق');
    }

    const getCartProductId = (item) => item.data?.data?.id ?? item.data?.id;

    // بررسی اینکه محصول در سبد هست یا نه
    const cartItem = cart.find(item => getCartProductId(item) === data?.data?.id);

   
    return (
        <div>
            <TempBoxWhite className={`max-[880px]:hidden`}>
                <div className='flex gap-12'>
                    <div>
                        <img 
                            src={mainImage} 
                            className='w-[424px] min-w-[424px] max-w-[424px] h-[350px] min-h-[350px] max-h-[350px] rounded-2xl object-cover' 
                            alt="" 
                        />
                        <div className="grid grid-cols-4 gap-3">
                            {allImages.map((img, i) => (
                            <img
                                key={i}
                                src={img}
                                alt={`Thumbnail ${i}`}
                                onClick={() => setMainImage(img)}
                                className={`w-full h-[80px] mt-4 object-cover rounded-xl cursor-pointer transition-all duration-200 hover:scale-110 ${
                                mainImage === img ? "ring-4 ring-BorderCustom" : "opacity-80"
                                }`}
                            />
                            ))}
                        </div>
                    </div>


                    <div className='w-full'>
                        <Text className={`font-bold text-lg`}>{data?.data?.om_name}</Text>

                        <Text className={`mt-4 h-[200px]`}>
                            {data?.data?.details}
                        </Text>


                        <div className='mt-[143px]'>
                            <div className='flex mt-8 gap-10'>
                                <div>
                                    <Text>
                                        الارتفاع : {data?.data?.height ? data?.data?.height : 'لا يوج'}
                                    </Text>
                                </div>
                                <div>
                                    <Text>
                                        العرض : {data?.data?.width ? data?.data?.width : 'لا يوج'}
                                    </Text>
                                </div>
                                <div>
                                    <Text>
                                        الطول : {data?.data?.length ? data?.data?.length : 'لا يوج'}
                                    </Text>
                                </div>
                                <div>
                                    <Text>
                                        الوزن : {data?.data?.weight ? data?.data?.weight : 'لا يوج'}
                                    </Text>
                                </div>
                            </div>

                            <div className='mt-[20px] flex justify-between items-center'>
                                <div className='flex gap-4 items-center'>
                                    <div className="relative">
                                        <Text className="text-lg flex items-center gap-2">{data?.data?.price} <img src={Rial} alt="" /></Text>
                                        <span className="absolute left-0 top-1/2 w-full h-[2px] bg-black rotate-[-10deg]"></span>
                                    </div>
                                    <Text className={`text-2xl font-bold text-red-500 flex items-center gap-2`}>{data?.data?.discounted_price} <img src={Rial} alt="" /></Text>
                                </div>

                                    {cartItem ? (
                                        <div className='flex gap-2 items-center'>
                                            <Button 
                                                onClick={() => updateQuantity(cartItem.data.id, cartItem.quantity - 1)}
                                                className="p-3 rounded-lg"
                                            >
                                                {cartItem.quantity === 1 ? (
                                                    <img onClick={() => {
                                                        removeFromCart(cartItem?.data?.data?.id)
                                                        toast.success('تم إزالة المنتج من سلة التسوق');
                                                    }} src={Delete} alt="حذف" className="w-6 h-6" />
                                                ) : (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                                        <path
                                                            fill="white"
                                                            fillRule="evenodd"
                                                            d="M5 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1"
                                                            clipRule="evenodd"
                                                        />
                                                    </svg>
                                                )}   
                                            </Button>

                                            <Text className='px-2 w-5'>{cartItem.quantity}</Text>

                                            <Button 
                                                onClick={() =>  updateQuantity(cartItem.data.id, cartItem.quantity + 1)}
                                                className="p-3 px-[18px] rounded-lg"
                                            >
                                                +
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button onClick={() => handleClick(data)} className={`flex py-3 px-[22px] gap-4`}>
                                            <img src={IconCardShopProduct} alt="" />
                                            <Text className={`text-white`}>إضافة</Text>
                                        </Button>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </TempBoxWhite>

            {/* <img src={data?.data?.image} className='w-[424px] min-w-[424px] max-w-[424px] h-[464px] min-h-[464px] max-h-[464px] rounded-2xl object-cover' alt="" /> */}
            <div className='mt-[90px] max-[480px]:mb-[100px] hidden max-[880px]:block'>
                {/* <AvatarButton
                    onTap={handleClick}
                    width="100%"
                    className={`w-full h-[300px]`}
                    height="100%"
                    borderRadius="8px"
                    borderRadiusImage="4px"
                    check={true}
                    image={mainImage}
                    boxFit="cover"
                /> */}
                <img 
                    src={mainImage} 
                    className='w-full h-[300px] min-h-[300px] max-h-[300px] rounded-lg object-cover' 
                    alt="" 
                />

                <div className="grid grid-cols-4 gap-3">
                    {allImages.map((img, i) => (
                    <img
                        key={i}
                        src={img}
                        alt={`Thumbnail ${i}`}
                        onClick={() => setMainImage(img)}
                        className={`w-full h-[80px] mt-4 object-cover rounded-xl cursor-pointer transition-all duration-200 hover:scale-110 ${
                        mainImage === img ? "ring-4 ring-BorderCustom" : "opacity-80"
                        }`}
                    />
                    ))}
                </div>

                <div className='flex items-center gap-2 py-6'>
                    <div className='border-2 border-BorderCustom bg-BorderCustom w-6 h-2 rounded-lg'/>
                    <Text className={`font-bold`}>{data?.data?.om_name}</Text>
                </div>

                <div className='hidden max-[480px]:flex'>
                    <hr className='w-[95%] m-auto border border-gray-300' />
                </div>

                <div className='flex justify-between items-center'>
                    <div className='flex items-center gap-2 py-6'>
                        <div className='border-2 border-BorderCustom bg-BorderCustom w-6 h-2 rounded-lg'/>
                        <Text className={`font-bold`}>السعر</Text>
                    </div>

                    <div className=' gap-4 items-center'>
                        <div className="relative">
                            <Text className="text-lg flex items-center gap-2">{data?.data?.price} <img src={Rial} alt="" /></Text>
                            <span className="absolute left-0 top-1/2 w-full h-[2px] bg-black rotate-[-10deg]"></span>
                        </div>
                        <Text className={`text-2xl font-bold text-red-500 flex items-center gap-2 ${!data?.data?.discounted_price && 'hidden'}`}>{data?.data?.discounted_price} <img src={Rial} alt="" /></Text>
                    </div>
                </div>

                <div className='hidden max-[480px]:flex'>
                    <hr className='w-[95%] m-auto border border-gray-300' />
                </div>

                <div className='flex items-center gap-2 py-6'>
                    <div className='border-2 border-BorderCustom bg-BorderCustom w-6 h-2 rounded-lg'/>
                    <Text className={`font-bold`}>الوصف</Text>
                </div>

                <Text>
                    {data?.data?.details}
                </Text>
                
                {!accessToken ? (
                    ''
                ) : (
                    <div className='fixed bottom-0 bg-white w-full right-0 p-4 hidden max-[480px]:flex'>
                        <div className='w-full'>
                            <Button className={`w-full py-2`} onClick={() => handleClick(data)}>
                            إضافة
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ContentProduct
